import { AlpineComponent } from 'alpinejs';

import triggerCustomEvent from '../../../javascripts/events/triggerCustom';

const Video = (): AlpineComponent => ({
  hasPosterModifier: 'video--has-poster',
  isPlayingModifier: 'video--is-playing',

  players: {
    youtube:
      '<iframe class="video__iframe" type="text/html" src="//www.youtube.com/embed/{{path}}?rel=0&autoplay={{autoplay}}&mute={{muted}}" muted allowfullscreen frameborder="0"/>',
  },

  hasPoster() {
    return this.$root.classList.contains(this.hasPosterModifier);
  },

  embedVideo(autoplay = 0) {
    let video = '';
    const source = this.$root.dataset.jsSource;

    video = this.players[source]
      .replace(/{{path}}/, this.$root.dataset.jsPath)
      .replace(/{{autoplay}}/, autoplay)
      .replace(/{{muted}}/, autoplay);
    
    this.$refs.container.innerHTML = video;
  },

  stopVideo() {
    while (this.$refs.container.firstChild) {
      this.$refs.container.removeChild(this.$refs.container.firstChild);
    }

    this.$root.classList.remove(this.isPlayingModifier);
  },

  onClickPlay() {
    triggerCustomEvent(window, 'Videos.stopAllVideos');
    window.addEventListener('Videos.stopAllVideos', () => {
      this.stopVideo();
    });

    this.embedVideo(1);

    this.$root.classList.add(this.isPlayingModifier);
  },

  init() {
    // hack to show first frame as poster on iphone/ipad: make it autoplay
    const agent = navigator.userAgent;
    if (agent.indexOf('iPhone') !== -1 || agent.indexOf('iPod') !== -1) {
      this.players.file =
        '<video class="video__player" src="{{path}}" autoplay controls></video>';
    }

    if (!this.hasPoster()) this.embedVideo(0);
  }
});

export default Video;
